import { defineStyle, defineStyleConfig, extendTheme, StyleFunctionProps, useColorMode } from "@chakra-ui/react";
import { ChakraTheme } from "@chakra-ui/theme";
import { theme as coreTheme } from "am-tax-fe-core";

export const useBgColor = () => {
    const { colorMode } = useColorMode();
    return colorMode === "light" ? "gray.50" : "gray.900";
};

export const useTextColor = () => {
    const { colorMode } = useColorMode();
    return colorMode === "light" ? "blackAlpha.800" : "whiteAlpha.800";
};

const themeOverrides = {
    colors: {
        red: {
            50: "#edd1d5",
            100: "#d38c97",
            200: "#c15e6d",
            300: "#b84758",
            400: "#b84758",
            500: "#af3043",
            600: "#a6192e", // brand secondary color
            700: "#951729",
            800: "#851425",
            900: "#741220",
        },
    },
    components: {
        Button: defineStyleConfig({
            variants: {
                naked: defineStyle({
                    height: "unset",
                    minWidth: "unset",
                }),
            },
        }),
        Tabs: {
            variants: {
                enclosed: (props: StyleFunctionProps) => ({
                    tab: {
                        _selected: {
                            borderBottomColor: props.colorMode === "light" ? "gray.50" : "gray.900",
                        },
                    },
                }),
            },
        },
    },
    styles: {
        global: {
            form: {
                ".required": {
                    "&::after": {
                        content: "' *'",
                    },
                },
            },
        },
    },
} as Partial<ChakraTheme>;

export const theme = extendTheme(coreTheme, themeOverrides);
